function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20 0c-2.32 0-4.547 1.08-6 2.787C12.547 1.08 10.32 0 8 0 3.893 0 .667 3.227.667 7.333c0 5.04 4.533 9.147 11.4 15.387L14 24.467l1.933-1.76c6.867-6.227 11.4-10.334 11.4-15.374C27.333 3.227 24.107 0 20 0zm-5.867 20.733l-.133.134-.133-.134C7.52 14.987 3.333 11.187 3.333 7.333c0-2.666 2-4.666 4.667-4.666 2.053 0 4.053 1.32 4.76 3.146h2.493c.694-1.826 2.694-3.146 4.747-3.146 2.667 0 4.667 2 4.667 4.666 0 3.854-4.187 7.654-10.534 13.4z",
  fill: "#FFF"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 25"
  }, props), _ref);
}

export default SvgHeart;